import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    '@global': {
      '.MuiAutocomplete-option[data-focus="true"]': {
        background: palette.trunkrs.secondary.violet.base,
        color: palette.common.white,
      },
    },
    root: {},
    inputRoot: {
      minWidth: spacing(12),
      paddingRight: `${spacing(2)}px !important`,
      marginBottom: 0,
      '& input::placeholder': {
        fontSize: 10,
      },
    },
    inputFocused: {},
    endAdornment: {},
    popper: {
      top: '-2px !important',
    },
    paper: {
      paddingTop: 0,
      borderTop: 'none',
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      width: '100%',
    },
  })

export default makeStyles(styles)
